/* eslint-disable no-negated-condition */

/* eslint-disable max-lines */
/* eslint-disable complexity */
import Config from './Config/Config.json'
import GetmoviesAppInfoData from './Services/Queries/GetmoviesAppInfoConfigService'
import './App.css'
import Amplify from 'aws-amplify'
import AwsConfig from './Config/AwsConfig'
import '@aws-amplify/ui/dist/style.css'
import { withAuthenticator } from 'aws-amplify-react'
import Preview from './Components/content/Preview'
import Dashboard from './Components/dashboard'
import permissions from './Components/UserPermissions/permissions'
import Footer from './Components/footer'
import MergePersons from './Components/Person/Merge Persons/MergePersons'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import NotFound from './Components/notfound'
import Content from './Components/content'
import React, { useState, useEffect } from 'react'
import appSyncClient from './Utils/AppSyncClient'
import { ApolloProvider } from 'react-apollo'
import PublishedContentsList from './Components/content/PublishedContentsList'
import UnPublishedContentsList from './Components/content/UnPublishedContentsList'
import EditContent from './Components/content/EditContent'
import CreatePeople from './Components/People/CreatePeople'
import ListPeople from './Components/People/ListPeople'
import MovieList from './Components/Movie/MoviesList/MoviesListMain'
import CreateEditTemplate from './Components/Templates/CreateEditTemplate'
import ListPNCounters from './Components/Filters/ListPushNotificationCounters'
import VideoPlayCounters from './Components/Filters/ListVideoPlayCounters'
import CreatorAnalytics from './Components/Filters/CreatorAnalytics'
import ImageTemplate from './Components/Templates/ImageTemplate'
import ClearHistory from './Components/content/ClearUserHistory'
import ListPages from './Components/Pages/ListPages'
import { Link } from 'react-router-dom'
import ImportMovies from './Components/content/ImportMovies'
import MultiplePersons from './Components/Person/multiplePersons/MultiplePersons'
import RankContents from './Components/content/RankContents'
import ListArticles from './Components/Articles/ListArticles'
import TeamsList from './Components/Teams/TeamsList'
import CreateOrEditTeam from './Components/Teams/CreateOrEditTeam'
import { Auth } from 'aws-amplify'
import GetUserPermissions from './Services/Queries/GetUserPermissions'
import { DefinedPermissions } from './Components/Constants/Permissions'
import FeaturedMatches from './Components/Teams/FeaturedMatches'
import UserSignUps from './Components/Filters/UserSignUps'
import ReferralUserSignups from './Components/Filters/ReferralUserSignups'
import CreatorsPoints from './Components/Filters/CreatorsPoints'
import DuplicateContent from './Components/content/DuplicateContent'
import ShareToSocialMedia from './Components/SocialMediaShare/ShareToSocialMedia'
import ListCompanies from './Components/Companies/ListCompanies'
import Job from './Components/Jobs'
import DraftJobs from './Components/Jobs/draftJobs'
import ActiveJobs from './Components/Jobs/activeJobs'
import ListCompany from './Components/Jobs/listCompany'
import ListJobs from './Components/Companies/ListJobs'
import EditJob from './Components/Jobs/EditJob'
import CreateCampaign from './Components/Filters/CreateCampaign'
import CreateMovie from './Components/Movie/CreateMovie'
import Movieedit from './Components/Movie/Movieedit'
import EditMovie from './Components/Movie/EditMovie'
import Persongrid from './Components/Movie/Persongrid'
// import EditPerson from './Components/Person/EditPerson'
import Editpersoncomponent from './Components/EditPerson/EditpersonData'
// import CreatePerson from './Components/Person/CreatePerson'
import ListMovies from './Components/Movie/ListMovies'
import Scrape from './Components/Movie/Scrape'
import ImportMoviePerson from './Components/ImportMoviePerson/ImportMoviePerson'
import Createlist from './Components/CreateListmoviespersons/Createlist'
import EditList from './Components/CreateListmoviespersons/EditList'
// import CrudCreateList from './Components/CreateListmoviespersons/CrudCreateList'
import ListMovieCollections from './Components/CreateListmoviespersons/ListMovieCollections'
import EditMovieCollection from './Components/CreateListmoviespersons/EditMovieCollection'
import CreateCollectionList from './Components/CreateListmoviespersons/CrudCreateList'
import CreateOrEditDynamicList from './Components/DynamicLists/CreateOrEditDynamicList'
import ListDynamicListsComponent from './Components/DynamicLists/ListDynamicListsComponent'
import DynamicListPageJson from './Components/DynamicLists/DynamicListPageJson'
import MovieAndPersonURLs from './Components/Movie/MovieAndPersonURLs'
import SearchPointsOverRide from './Components/Movie/SearchPointsOverRide'
import UserReportDashboard from './Components/Person/TfidbUserReports'
import createTag from './Components/Tags/createTag'
import allTags from './Components/Tags/allTags'
import editTags from './Components/Tags/editTags'
import ExtendedInfoAccordians from './Components/Person/PersonTOC/ExtendedInfoAccordians'
import SendPNManuallyInputForm from './Components/PN/ManualPN'
import ImportPersonExtendedInfo from './Components/ImportMoviePerson/ImportPersonExtendedInfo'

Amplify.configure(AwsConfig)

function App() {
  const [hambergerColor, setHambergerColor] = useState()
  const [isOpen, setIsopen] = useState(false)
  const [loggedInUserPermissions, setLoggedInUserPermissions] = useState([])
  const ToggleSidebar = () => (isOpen === true ? setIsopen(false) : setIsopen(true))

  const viewRankedContentsPermission = loggedInUserPermissions.includes(
    DefinedPermissions.viewRankedContentsPermission,
  )

  const articlesListPermission = loggedInUserPermissions.includes(
    DefinedPermissions.articlesListPermission,
  )
  const contentCreateAndEditPermission = loggedInUserPermissions.includes(
    DefinedPermissions.contentCreateAndEditPermission,
  )
  const viewUnpublishedContentsPermission = loggedInUserPermissions.includes(
    DefinedPermissions.viewUnpublishedContentsPermission,
  )
  const viewPublishedContentsPermission = loggedInUserPermissions.includes(
    DefinedPermissions.viewPublishedContentsPermission,
  )
  const viewPushNotificationCountersListPermission = loggedInUserPermissions.includes(
    DefinedPermissions.viewPushNotificationCountersListPermission,
  )
  const viewVideoPlayCountersListPermission = loggedInUserPermissions.includes(
    DefinedPermissions.viewVideoPlayCountersListPermission,
  )
  const previewBoxOfficePermission = loggedInUserPermissions.includes(
    DefinedPermissions.previewBoxOfficePermission,
  )
  const createPeoplePermission = loggedInUserPermissions.includes(
    DefinedPermissions.createPeoplePermission,
  )
  const listPeoplePermission = loggedInUserPermissions.includes(
    DefinedPermissions.listPeoplePermission,
  )
  const contentAnalyticsPermission = loggedInUserPermissions.includes(
    DefinedPermissions.contentAnalyticsPermission,
  )
  const CollectionCreatePermission = loggedInUserPermissions.includes(
    DefinedPermissions.CollectionCreate,
  )
  const CreateMovieListPermission = loggedInUserPermissions.includes(
    DefinedPermissions.MovieListCreate,
  )
  const createDynamicListPermission = loggedInUserPermissions.includes(
    DefinedPermissions.DynamicListCreate,
  )
  const CreatePersonPermission = loggedInUserPermissions.includes(DefinedPermissions.CreatePerson)
  const allPersonsPermission = loggedInUserPermissions.includes(DefinedPermissions.allPersonsView)
  const editPersonPermission = loggedInUserPermissions.includes(
    DefinedPermissions.EditPeronPermission,
  )
  const createMoviePermission = loggedInUserPermissions.includes(
    DefinedPermissions.CreateMoviePermission,
  )
  const editMoviePermission = loggedInUserPermissions.includes(
    DefinedPermissions.EditMoviePermission,
  )
  const allMoviesPermission = loggedInUserPermissions.includes(DefinedPermissions.allMoviesView)
  const MergePersonsPermission = loggedInUserPermissions.includes(
    DefinedPermissions.MergePersonsPermission,
  )
  const movielistView = loggedInUserPermissions.includes(DefinedPermissions.movielistView)
  const DynamiclistViewPermission = loggedInUserPermissions.includes(
    DefinedPermissions.DynamiclistView,
  )
  const CollectionViewPermission = loggedInUserPermissions.includes(
    DefinedPermissions.CollectionView,
  )
  const ImportMoviesPersonsPermission = loggedInUserPermissions.includes(
    DefinedPermissions.ImportMoviesPersons,
  )
  const ScrapePermission = loggedInUserPermissions.includes(DefinedPermissions.ScrapePermission)
  const CreateJob = loggedInUserPermissions.includes(DefinedPermissions.CreateJob)
  const activeJobs = loggedInUserPermissions.includes(DefinedPermissions.activeJobs)
  const draftJobs = loggedInUserPermissions.includes(DefinedPermissions.draftJobs)
  const staticMobileNumbers = ['+919705234094', '+919491870436', '+918501098096']
  const displayCreatorsPointsReport = staticMobileNumbers.includes(
    Auth.user.attributes.phone_number,
  )

  const hambergerColorStyle = { main: { backgroundColor: hambergerColor } }
  const hambergerColorStyleBlack = { main: { backgroundColor: 'black' } }

  useEffect(() => {
    const getLoggedInUserPermissions = async () => {
      const input = {
        mobileNumber: Auth.user.attributes.phone_number,
      }
      const userPermissions = await GetUserPermissions(input)
      const permissions = []
      const permissionsArr = []
      if (userPermissions && userPermissions.userRolesAndPermissions) {
        userPermissions.userRolesAndPermissions.forEach(item => {
          permissions.push(...item.permissions)
        })
        permissions.forEach(permission => {
          permissionsArr.push(permission.name)
        })
      }

      const getHambergerBackgroundColor = await GetmoviesAppInfoData()

      setHambergerColor(
        getHambergerBackgroundColor.getMoviesAppInfoConfig &&
          getHambergerBackgroundColor.getMoviesAppInfoConfig.siteColour &&
          getHambergerBackgroundColor.getMoviesAppInfoConfig.siteColour,
      )
      setLoggedInUserPermissions(permissionsArr)
    }

    getLoggedInUserPermissions()
  }, [])
  return (
    <div className='App wrapper Container ' style={{ backgroundColor: 'white ' }}>
      <ApolloProvider client={appSyncClient}>
        <BrowserRouter>
          <div className='row'>
            <div className={isOpen ? 'col-md-3' : 'col-md-1'}>
              <div className='container-fluid mt-3'>
                <div onClick={ToggleSidebar}>
                  <i className='fa fa-bars'></i>
                </div>
                <div
                  className={` sidebar ${isOpen === true ? 'active' : ''} `}
                  style={
                    Config.Environment === 'Production'
                      ? hambergerColorStyle.main
                      : hambergerColorStyleBlack.main
                  }
                >
                  <div className='sd-header'>
                    <div onClick={ToggleSidebar}>
                      <i className='fa fa-times'></i>
                    </div>
                  </div>
                  <div className='sd-body'>
                    <div
                      className='panel-group'
                      id='accordion'
                      role='tablist'
                      aria-multiselectable='true'
                    >
                      <div className='panel panel-default'>
                        <div className='panel-heading' role='tab' id='headingOne'>
                          <text className='panel-title'>
                            <a
                              className='collapsed'
                              role='button'
                              data-toggle='collapse'
                              data-parent='#accordion'
                              href='#collapseOne'
                              aria-expanded='false'
                              aria-controls='collapseOne'
                            >
                              Content
                            </a>
                          </text>
                        </div>
                        <div
                          id='collapseOne'
                          className='panel-collapse collapse in'
                          role='tabpanel'
                          aria-labelledby='headingOne'
                        >
                          <div className='panel-body'>
                            <ul
                              className='nav nav-pills nav-sidebar flex-column'
                              data-widget='treeview'
                              role='menu'
                              data-accordion='false'
                            >
                              {contentCreateAndEditPermission ? (
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to='/content'>
                                      <p>Create Content</p>
                                    </Link>
                                  </a>
                                </li>
                              ) : null}

                              {contentCreateAndEditPermission ? (
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to={'/editContent'}>
                                      <p>Edit Content</p>
                                    </Link>
                                  </a>
                                </li>
                              ) : null}
                              {viewRankedContentsPermission ? (
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to={'/rankContent'}>
                                      <p>Rank Content</p>
                                    </Link>
                                  </a>
                                </li>
                              ) : null}

                              {/* {viewRankedContentsPermission ? ( */}
                              <li className='nav-item'>
                                <a className='nav-link'>
                                  <i className='nav-icon far fa-circle text-primary' />
                                  <Link to={'/ImportMovies'}>
                                    <p>Import Movie</p>
                                  </Link>
                                </a>
                              </li>
                              {/* ) : null} */}

                              {viewPublishedContentsPermission ? (
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to='/publishedContents'>
                                      <p>Published Contents </p>
                                    </Link>
                                  </a>
                                </li>
                              ) : null}
                              {viewUnpublishedContentsPermission ? (
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to='/unPublishedContents'>
                                      <p>Unpublished Contents </p>
                                    </Link>
                                  </a>
                                </li>
                              ) : null}
                              <li className='nav-item'>
                                <a className='nav-link'>
                                  <i className='nav-icon far fa-circle text-primary' />
                                  <Link to='/ImageTemplate'>
                                    <p>Image Template</p>
                                  </Link>
                                </a>
                              </li>
                              {previewBoxOfficePermission ? (
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to='/clearUserHistory'>
                                      <p>Preview Box Office</p>
                                    </Link>
                                  </a>
                                </li>
                              ) : null}
                            </ul>
                          </div>
                        </div>
                      </div>
                      {createPeoplePermission || listPeoplePermission ? (
                        <div className='panel panel-default'>
                          <div className='panel-heading' role='tab' id='headingTwo'>
                            <text className='panel-title'>
                              <a
                                className='collapsed'
                                role='button'
                                data-toggle='collapse'
                                data-parent='#accordion'
                                href='#collapseTwo'
                                aria-expanded='false'
                                aria-controls='collapseTwo'
                              >
                                People
                              </a>
                            </text>
                          </div>
                          <div
                            id='collapseTwo'
                            className='panel-collapse collapse'
                            role='tabpanel'
                            aria-labelledby='headingTwo'
                          >
                            <div className='panel-body'>
                              <ul
                                className='nav nav-pills nav-sidebar flex-column'
                                data-widget='treeview'
                                role='menu'
                                data-accordion='false'
                              >
                                {createPeoplePermission ? (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to='/createPeople'>
                                        <p>Create People</p>
                                      </Link>
                                    </a>
                                  </li>
                                ) : null}
                                {listPeoplePermission ? (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to='/listPeople'>
                                        <p>List People</p>
                                      </Link>
                                    </a>
                                  </li>
                                ) : null}
                              </ul>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {viewPushNotificationCountersListPermission ||
                      viewVideoPlayCountersListPermission ||
                      contentAnalyticsPermission ? (
                        <div className='panel panel-default'>
                          <div className='panel-heading' role='tab' id='headingThree'>
                            <text className='panel-title'>
                              <a
                                className='collapsed'
                                role='button'
                                data-toggle='collapse'
                                data-parent='#accordion'
                                href='#collapseThree'
                                aria-expanded='false'
                                aria-controls='collapseThree'
                              >
                                Reports
                              </a>
                            </text>
                          </div>
                          <div
                            id='collapseThree'
                            className='panel-collapse collapse'
                            role='tabpanel'
                            aria-labelledby='headingThree'
                          >
                            <div className='panel-body'>
                              <ul
                                className='nav nav-pills nav-sidebar flex-column'
                                data-widget='treeview'
                                role='menu'
                                data-accordion='false'
                              >
                                {viewPushNotificationCountersListPermission ? (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to='/listPushNotificationCounters'>
                                        <p>Push Notification Counters </p>
                                      </Link>
                                    </a>
                                  </li>
                                ) : null}
                              </ul>
                            </div>
                            <div className='panel-body'>
                              <ul
                                className='nav nav-pills nav-sidebar flex-column'
                                data-widget='treeview'
                                role='menu'
                                data-accordion='false'
                              >
                                {viewVideoPlayCountersListPermission ? (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to='/listVideoPlayCounters'>
                                        <p>Video Play Counters</p>
                                      </Link>
                                    </a>
                                  </li>
                                ) : null}
                                {contentAnalyticsPermission ? (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to={'/creatorAnalytics'}>
                                        <p>Creator Analytics</p>
                                      </Link>
                                    </a>
                                  </li>
                                ) : null}
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to={'/userSignUps'}>
                                      <p>LuckyDraw User SignUps</p>
                                    </Link>
                                  </a>
                                </li>
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to={'/referralUserSignups'}>
                                      <p>Referral User SignUps</p>
                                    </Link>
                                  </a>
                                </li>
                                {displayCreatorsPointsReport ? (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to={'/creatorsPointsReport'}>
                                        <p>Creator Points</p>
                                      </Link>
                                    </a>
                                  </li>
                                ) : null}
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to={'/createCampaign'}>
                                      <p>Create Campaign</p>
                                    </Link>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <div className='panel panel-default'>
                        <div className='panel-heading' role='tab' id='headingFour'>
                          <text className='panel-title'>
                            <a
                              className='collapsed'
                              role='button'
                              data-toggle='collapse'
                              data-parent='#accordion'
                              href='#collapseFour'
                              aria-expanded='false'
                              aria-controls='collapseFour'
                            >
                              Pages
                            </a>
                          </text>
                        </div>
                        <div
                          id='collapseFour'
                          className='panel-collapse collapse'
                          role='tabpanel'
                          aria-labelledby='headingFour'
                        >
                          <div className='panel-body'>
                            <ul
                              className='nav nav-pills nav-sidebar flex-column'
                              data-widget='treeview'
                              role='menu'
                              data-accordion='false'
                            >
                              <li className='nav-item'>
                                <a className='nav-link'>
                                  <i className='nav-icon far fa-circle text-primary' />
                                  <Link to='/listPages'>
                                    <p>List Pages </p>
                                  </Link>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      {articlesListPermission ? (
                        <div className='panel panel-default'>
                          <div className='panel-heading' role='tab' id='headingFive'>
                            <text className='panel-title'>
                              <a
                                className='collapsed'
                                role='button'
                                data-toggle='collapse'
                                data-parent='#accordion'
                                href='#collapseFive'
                                aria-expanded='false'
                                aria-controls='collapseFive'
                              >
                                Articles
                              </a>
                            </text>
                          </div>
                          <div
                            id='collapseFive'
                            className='panel-collapse collapse in'
                            role='tabpanel'
                            aria-labelledby='headingFive'
                          >
                            <div className='panel-body'>
                              <ul
                                className='nav nav-pills nav-sidebar flex-column'
                                data-widget='treeview'
                                role='menu'
                                data-accordion='false'
                              >
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to='/listArticles'>
                                      <p>List Articles</p>
                                    </Link>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {articlesListPermission ? (
                        <div className='panel panel-default'>
                          <div className='panel-heading' role='tab' id='headingFive'>
                            <text className='panel-title'>
                              <a
                                className='collapsed'
                                role='button'
                                data-toggle='collapse'
                                data-parent='#accordion'
                                href='#collapseSix'
                                aria-expanded='false'
                                aria-controls='collapseSix'
                              >
                                Team
                              </a>
                            </text>
                          </div>
                          <div
                            id='collapseSix'
                            className='panel-collapse collapse in'
                            role='tabpanel'
                            aria-labelledby='headingSix'
                          >
                            <div className='panel-body'>
                              <ul
                                className='nav nav-pills nav-sidebar flex-column'
                                data-widget='treeview'
                                role='menu'
                                data-accordion='false'
                              >
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to='/listTeams'>
                                      <p> Teams List</p>
                                    </Link>
                                  </a>
                                </li>
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to='/featuredMatches'>
                                      <p> Featured Matches List</p>
                                    </Link>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {ScrapePermission && (
                        <div className='panel panel-default'>
                          <div className='panel-heading' role='tab' id='headingTen'>
                            <text className='panel-title'>
                              <a
                                className='collapsed'
                                role='button'
                                data-toggle='collapse'
                                data-parent='#accordion'
                                href='#collapseThirteen'
                                aria-expanded='false'
                                aria-controls='collapseThirteen'
                              >
                                Scrape
                              </a>
                            </text>
                          </div>
                          <div
                            id='collapseThirteen'
                            className='panel-collapse collapse in'
                            role='tabpanel'
                            aria-labelledby='collapseThirteen'
                          >
                            <div className='panel-body'>
                              <ul
                                className='nav nav-pills nav-sidebar flex-column'
                                data-widget='treeview'
                                role='menu'
                                data-accordion='false'
                              >
                                {ScrapePermission && (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to={'/Scrape'}>
                                        <p>Scrape</p>
                                      </Link>
                                    </a>
                                  </li>
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className='panel panel-default'>
                        <div className='panel-heading' role='tab' id='headingSix'>
                          <text className='panel-title'>
                            <a
                              className='collapsed'
                              role='button'
                              data-toggle='collapse'
                              data-parent='#accordion'
                              href='#collapseSeven'
                              aria-expanded='false'
                              aria-controls='collapseSeven'
                            >
                              Job
                            </a>
                          </text>
                        </div>
                        <div
                          id='collapseSeven'
                          className='panel-collapse collapse in'
                          role='tabpanel'
                          aria-labelledby='headingSeven'
                        >
                          <div className='panel-body'>
                            <ul
                              className='nav nav-pills nav-sidebar flex-column'
                              data-widget='treeview'
                              role='menu'
                              data-accordion='false'
                            >
                              {CreateJob && (
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to='/Jobs'>
                                      <p> Create Job</p>
                                    </Link>
                                  </a>
                                </li>
                              )}

                              {draftJobs && (
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to='/DraftJobs'>
                                      <p> Draft Jobs</p>
                                    </Link>
                                  </a>
                                </li>
                              )}
                              {activeJobs && (
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to='/ActiveJobs'>
                                      <p> Active Jobs</p>
                                    </Link>
                                  </a>
                                </li>
                              )}
                              {contentCreateAndEditPermission ? (
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to='/listCompanies'>
                                      <p> List Companies</p>
                                    </Link>
                                  </a>
                                </li>
                              ) : null}
                            </ul>
                          </div>
                        </div>
                      </div>
                      <>
                        <div className='panel panel-default'>
                          <div className='panel-heading' role='tab' id='headingSix'>
                            <text className='panel-title'>
                              <a
                                className='collapsed'
                                role='button'
                                data-toggle='collapse'
                                data-parent='#accordion'
                                href='#collapseEight'
                                aria-expanded='false'
                                aria-controls='collapseEight'
                              >
                                Persons
                              </a>
                            </text>
                          </div>
                          <div
                            id='collapseEight'
                            className='panel-collapse collapse in'
                            role='tabpanel'
                            aria-labelledby='headingEight'
                          >
                            <div className='panel-body'>
                              <ul
                                className='nav nav-pills nav-sidebar flex-column'
                                data-widget='treeview'
                                role='menu'
                                data-accordion='false'
                              >
                                {CreatePersonPermission && (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to={'/createperson'}>
                                        <p>Create Person</p>
                                      </Link>
                                    </a>
                                  </li>
                                )}

                                {editPersonPermission && (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to={'/editperson'}>
                                        <p>Edit Person</p>
                                      </Link>
                                    </a>
                                  </li>
                                )}
                                {allPersonsPermission && (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to={'/listpersons'}>
                                        <p>All Persons</p>
                                      </Link>
                                    </a>
                                  </li>
                                )}
                                {MergePersonsPermission && (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to={'/MergePersons'}>
                                        <p>Merge Persons</p>
                                      </Link>
                                    </a>
                                  </li>
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className='panel panel-default'>
                          <div className='panel-heading' role='tab' id='headingSix'>
                            <text className='panel-title'>
                              <a
                                className='collapsed'
                                role='button'
                                data-toggle='collapse'
                                data-parent='#accordion'
                                href='#collapseNine'
                                aria-expanded='false'
                                aria-controls='collapseNine'
                              >
                                Movies
                              </a>
                            </text>
                          </div>
                          <div
                            id='collapseNine'
                            className='panel-collapse collapse in'
                            role='tabpanel'
                            aria-labelledby='headingNine'
                          >
                            <div className='panel-body'>
                              <ul
                                className='nav nav-pills nav-sidebar flex-column'
                                data-widget='treeview'
                                role='menu'
                                data-accordion='false'
                              >
                                {createMoviePermission && (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to='/createMovie'>
                                        <p>Create Movie/Webseries</p>
                                      </Link>
                                    </a>
                                  </li>
                                )}

                                {editMoviePermission && (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to={'/editmovie'}>
                                        <p>Edit Movie/Webseries</p>
                                      </Link>
                                    </a>
                                  </li>
                                )}
                                {allMoviesPermission && (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to={'/listmovies'}>
                                        <p>All Movies</p>
                                      </Link>
                                    </a>
                                  </li>
                                )}
                                {
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to={'/getmovieandpersonurls'}>
                                        <p>Movie And PersonURLs</p>
                                      </Link>
                                    </a>
                                  </li>
                                }
                                {
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to={'/pointsoverride'}>
                                        <p>PointsOverRide</p>
                                      </Link>
                                    </a>
                                  </li>
                                }
                                {
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to={'/TfidbUserReport'}>
                                        <p>TfidbUserReport</p>
                                      </Link>
                                    </a>
                                  </li>
                                }
                                {/* <Route exact path='/getmovieandpersonurls' component={MovieAndPersonURLs} /> */}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </>
                      {articlesListPermission ? (
                        <div className='panel panel-default'>
                          <div className='panel-heading' role='tab' id='headingSix'>
                            <text className='panel-title'>
                              <a
                                className='collapsed'
                                role='button'
                                data-toggle='collapse'
                                data-parent='#accordion'
                                href='#collapseEleven'
                                aria-expanded='false'
                                aria-controls='collapseEleven'
                              >
                                User Permissions
                              </a>
                            </text>
                          </div>
                          <div
                            id='collapseEleven'
                            className='panel-collapse collapse in'
                            role='tabpanel'
                            aria-labelledby='headingEleven'
                          >
                            <div className='panel-body'>
                              <ul
                                className='nav nav-pills nav-sidebar flex-column'
                                data-widget='treeview'
                                role='menu'
                                data-accordion='false'
                              >
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to='/permissions'>
                                      <p>Permissions List</p>
                                    </Link>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <>
                        <div className='panel panel-default'>
                          <div className='panel-heading' role='tab' id='headingSix'>
                            <text className='panel-title'>
                              <a
                                className='collapsed'
                                role='button'
                                data-toggle='collapse'
                                data-parent='#accordion'
                                href='#collapseTwelve'
                                aria-expanded='false'
                                aria-controls='collapseTwelve'
                              >
                                Movie Lists
                              </a>
                            </text>
                          </div>
                          <div
                            id='collapseTwelve'
                            className='panel-collapse collapse in'
                            role='tabpanel'
                            aria-labelledby='headingTwelve'
                          >
                            <div className='panel-body'>
                              <ul
                                className='nav nav-pills nav-sidebar flex-column'
                                data-widget='treeview'
                                role='menu'
                                data-accordion='false'
                              >
                                {CreateMovieListPermission && (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to='/createlist'>
                                        <p>Create List</p>
                                      </Link>
                                    </a>
                                  </li>
                                )}
                                {movielistView && (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to={'/MovieList'}>
                                        <p>All Movie List</p>
                                      </Link>
                                    </a>
                                  </li>
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </>
                      <>
                        <div className='panel panel-default'>
                          <div className='panel-heading' role='tab' id='headingSix'>
                            <text className='panel-title'>
                              <a
                                className='collapsed'
                                role='button'
                                data-toggle='collapse'
                                data-parent='#accordion'
                                href='#collapsefourteen'
                                aria-expanded='false'
                                aria-controls='collapsefourteen'
                              >
                                Dynamic List
                              </a>
                            </text>
                          </div>
                          <div
                            id='collapsefourteen'
                            className='panel-collapse collapse in'
                            role='tabpanel'
                            aria-labelledby='headingfourteen'
                          >
                            <div className='panel-body'>
                              <ul
                                className='nav nav-pills nav-sidebar flex-column'
                                data-widget='treeview'
                                role='menu'
                                data-accordion='false'
                              >
                                {createDynamicListPermission && (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to='/createDynamicList'>
                                        <p>Create Dynamic List</p>
                                      </Link>
                                    </a>
                                  </li>
                                )}
                                {DynamiclistViewPermission && (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to='/dynamicLists'>
                                        <p>All Dynamic List</p>
                                      </Link>
                                    </a>
                                  </li>
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </>
                      <>
                        <div className='panel panel-default'>
                          <div className='panel-heading' role='tab' id='headingSix'>
                            <text className='panel-title'>
                              <a
                                className='collapsed'
                                role='button'
                                data-toggle='collapse'
                                data-parent='#accordion'
                                href='#collapsefifteen'
                                aria-expanded='false'
                                aria-controls='collapsefifteen'
                              >
                                Collection
                              </a>
                            </text>
                          </div>
                          <div
                            id='collapsefifteen'
                            className='panel-collapse collapse in'
                            role='tabpanel'
                            aria-labelledby='headingfifteen'
                          >
                            <div className='panel-body'>
                              <ul
                                className='nav nav-pills nav-sidebar flex-column'
                                data-widget='treeview'
                                role='menu'
                                data-accordion='false'
                              >
                                {CollectionCreatePermission && (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to={'/CreateCollectionList'}>
                                        <p>create List Collection </p>
                                      </Link>
                                    </a>
                                  </li>
                                )}
                                {CollectionViewPermission && (
                                  <li className='nav-item'>
                                    <a className='nav-link'>
                                      <i className='nav-icon far fa-circle text-primary' />
                                      <Link to={'/ListMovieCollections'}>
                                        <p>All Movie Collections</p>
                                      </Link>
                                    </a>
                                  </li>
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </>
                      {/* tags */}
                      <>
                        <div className='panel panel-default'>
                          <div className='panel-heading' role='tab' id='headingSix'>
                            <text className='panel-title'>
                              <a
                                className='collapsed'
                                role='button'
                                data-toggle='collapse'
                                data-parent='#accordion'
                                href='#collapseSeventeen'
                                aria-expanded='false'
                                aria-controls='collapseSeventeen'
                              >
                                Tags
                              </a>
                            </text>
                          </div>
                          <div
                            id='collapseSeventeen'
                            className='panel-collapse collapse in'
                            role='tabpanel'
                            aria-labelledby='headingfifteen'
                          >
                            <div className='panel-body'>
                              <ul
                                className='nav nav-pills nav-sidebar flex-column'
                                data-widget='treeview'
                                role='menu'
                                data-accordion='false'
                              >
                                {/* {CollectionCreatePermission && ( */}
                                {/* <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to={'/createTag'}>
                                      <p>Create Tags </p>
                                    </Link>
                                  </a>
                                </li> */}

                                {/* <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to={'/editTags'}>
                                      <p>Edit Tags</p>
                                    </Link>
                                  </a>
                                </li> */}
                                {/* )} */}
                                {/* {CollectionViewPermission && ( */}
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to={'/allTags'}>
                                      <p>All Tags</p>
                                    </Link>
                                  </a>
                                </li>
                                {/* )} */}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </>
                      {/* tags */}
                      <>
                        <div className='panel panel-default'>
                          <div className='panel-heading' role='tab' id='headingSix'>
                            <text className='panel-title'>
                              <a
                                className='collapsed'
                                role='button'
                                data-toggle='collapse'
                                data-parent='#accordion'
                                href='#collapsesixteen'
                                aria-expanded='false'
                                aria-controls='collapsesixteen'
                              >
                                TFIDB
                              </a>
                            </text>
                          </div>
                          <div
                            id='collapsesixteen'
                            className='panel-collapse collapse in'
                            role='tabpanel'
                            aria-labelledby='headingsixteen'
                          >
                            <div className='panel-body'>
                              <ul
                                className='nav nav-pills nav-sidebar flex-column'
                                data-widget='treeview'
                                role='menu'
                                data-accordion='false'
                              >
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to='/tfidbPageJson'>
                                      <p>TFIDB Page Json</p>
                                    </Link>
                                  </a>
                                </li>
                                <li className='nav-item'>
                                  <a className='nav-link'>
                                    <i className='nav-icon far fa-circle text-primary' />
                                    <Link to='/TfidbPN'>
                                      <p>TFIDB PN</p>
                                    </Link>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </>
                      <>
                        {ImportMoviesPersonsPermission && (
                          <div className='panel panel-default'>
                            <div className='panel-heading' role='tab' id='headingTen'>
                              <text className='panel-title'>
                                <a
                                  className='collapsed'
                                  role='button'
                                  data-toggle='collapse'
                                  data-parent='#accordion'
                                  href='#collapseTen'
                                  aria-expanded='false'
                                  aria-controls='collapseTen'
                                >
                                  Import Movie /Person /Webseries
                                </a>
                              </text>
                            </div>
                            <div
                              id='collapseTen'
                              className='panel-collapse collapse in'
                              role='tabpanel'
                              aria-labelledby='headingTen'
                            >
                              <div className='panel-body'>
                                <ul
                                  className='nav nav-pills nav-sidebar flex-column'
                                  data-widget='treeview'
                                  role='menu'
                                  data-accordion='false'
                                >
                                  {ImportMoviesPersonsPermission && (
                                    <li className='nav-item'>
                                      <a className='nav-link'>
                                        <i className='nav-icon far fa-circle text-primary' />
                                        <Link to={'/importMoviePerson'}>
                                          <p>Import Movie /Person /Webseries </p>
                                        </Link>
                                      </a>
                                    </li>
                                  )}
                                </ul>
                                <ul
                                  className='nav nav-pills nav-sidebar flex-column'
                                  data-widget='treeview'
                                  role='menu'
                                  data-accordion='false'
                                >
                                  {ImportMoviesPersonsPermission && (
                                    <li className='nav-item'>
                                      <a className='nav-link'>
                                        <i className='nav-icon far fa-circle text-primary' />
                                        <Link to={'/ImportPersonExtendedInfo'}>
                                          <p>Import Person ExtendedInfo</p>
                                        </Link>
                                      </a>
                                    </li>
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    </div>
                  </div>
                </div>
                <div
                  className={`sidebar-overlay ${isOpen === true ? 'active' : ''}`}
                  onClick={ToggleSidebar}
                ></div>
              </div>
            </div>
            <div className='col-md-9'>
              <Switch>
                {window.location.href.indexOf('editContent?') >= 0 ? (
                  <Route component={EditContent} />
                ) : null}
                {window.location.href.indexOf('shareContent?') >= 0 ? (
                  <Route component={ShareToSocialMedia} />
                ) : null}
                {window.location.href.indexOf('duplicateContent?') >= 0 ? (
                  <Route component={DuplicateContent} />
                ) : null}
                {window.location.href.indexOf('CreateCollectionList') >= 0 ? (
                  <Route component={CreateCollectionList} />
                ) : null}
                {window.location.href.indexOf('editPeople?') >= 0 ? (
                  <Route component={CreatePeople} />
                ) : null}
                {window.location.href.indexOf('rankContent') >= 0 ? (
                  <Route component={RankContents} />
                ) : null}
                {window.location.href.indexOf('ImportMovies') !== -1 ? (
                  <Route component={ImportMovies} />
                ) : null}
                {window.location.href.indexOf('editJob?') !== -1 ? (
                  <Route component={EditJob} />
                ) : null}
                {window.location.href.indexOf('editperson?') >= 0 ? (
                  <Route component={ExtendedInfoAccordians} />
                ) : null}
                {window.location.href.indexOf('editperson') >= 0 ? (
                  <Route component={ExtendedInfoAccordians} />
                ) : null}
                {window.location.href.indexOf('createperson') >= 0 ? (
                  <Route component={ExtendedInfoAccordians} />
                ) : null}
                {window.location.href.indexOf('MultiplePersons') !== -1 ? (
                  <Route component={MultiplePersons} />
                ) : null}
                {window.location.href.indexOf('editlist?') !== -1 ? (
                  <Route component={EditList} />
                ) : null}
                {window.location.href.indexOf('createlist') !== -1 ? (
                  <Route component={Createlist} />
                ) : null}
                {window.location.href.indexOf('createDynamicList') !== -1 ? (
                  <Route component={CreateOrEditDynamicList} />
                ) : null}
                {window.location.href.indexOf('createTag') !== -1 ? (
                  <Route component={createTag} />
                ) : null}
                {window.location.href.indexOf('allTags') !== -1 ? (
                  <Route component={allTags} />
                ) : null}
                {window.location.href.indexOf('editTags') !== -1 ? (
                  <Route component={editTags} />
                ) : null}
                {window.location.href.indexOf('tfidbPageJson') !== -1 ? (
                  <Route component={DynamicListPageJson} />
                ) : null}

                {window.location.href.indexOf('dynamicLists') !== -1 ? (
                  <Route component={ListDynamicListsComponent} />
                ) : null}
                {window.location.href.indexOf('createMovie') >= 0 ? (
                  <Route component={CreateMovie} />
                ) : null}
                {window.location.href.indexOf('editmoviecollection?') !== -1 ? (
                  <Route component={EditMovieCollection} />
                ) : null}
                {window.location.href.indexOf('editmovie?') >= 0 ? (
                  <Route component={EditMovie} />
                ) : null}
                {window.location.href.indexOf('editmovie') >= 0 ? (
                  <Route component={EditMovie} />
                ) : null}
                {window.location.href.indexOf('listmovies?') >= 0 ? (
                  <Route component={ListMovies} />
                ) : null}
                {window.location.href.indexOf('listmovies') !== -1 ? (
                  <Route component={ListMovies} />
                ) : null}
                {window.location.href.indexOf('MovieList') >= 0 ? (
                  <Route component={MovieList} />
                ) : null}
                {window.location.href.indexOf('listpersons') >= 0 ? (
                  <Route component={Persongrid} />
                ) : null}
                {window.location.href.indexOf('MergePersons?') >= 0 ? (
                  <Route component={MergePersons} />
                ) : null}
                {window.location.href.indexOf('permissions?') >= 0 ? (
                  <Route component={permissions} />
                ) : null}
                {window.location.href.indexOf('createMovie') !== -1 ? (
                  <Route component={CreateMovie} />
                ) : null}
                {window.location.href.indexOf('getmovieandpersonurls') !== -1 ? (
                  <Route component={MovieAndPersonURLs} />
                ) : null}
                {window.location.href.indexOf('TfidbPN') !== -1 ? (
                  <Route component={SendPNManuallyInputForm} />
                ) : null}
                {window.location.href.indexOf('ImportPersonExtendedInfo') !== -1 ? (
                  <Route component={ImportPersonExtendedInfo} />
                ) : null}
                <Route exact path='/permissions' component={permissions} />
                <Route exact path='/' component={Dashboard} />
                <Route exact path='/clearUserHistory' component={ClearHistory} />
                <Route exact path='/createMovie' component={CreateMovie} />
                <Route exact path='/editlist' component={EditList} />
                <Route exact path='/movieedit' component={Movieedit} />
                <Route exact path='/editmovie' component={EditMovie} />
                <Route exact path='/createlist' component={Createlist} />
                <Route exact path='/createDynamicList' component={CreateOrEditDynamicList} />
                <Route exact path='/createTag' component={createTag} />
                <Route exact path='/allTags' component={allTags} />
                <Route exact path='/editTags' component={editTags} />

                <Route exact path='/tfidbPageJson' component={DynamicListPageJson} />
                <Route exact path='/dynamicLists' component={ListDynamicListsComponent} />
                <Route exact path='/listpersons' component={Persongrid} />
                <Route exact path='/MergePersons' component={MergePersons} />
                <Route exact path='/MultiplePersons' component={MultiplePersons} />
                <Route exact path='/CreateCollectionList' component={CreateCollectionList} />
                <Route exact path='/ListMovieCollections' component={ListMovieCollections} />
                <Route exact path='/editmoviecollection' component={EditMovieCollection} />
                <Route exact path='/importMoviePerson' component={ImportMoviePerson} />
                <Route exact path='/listmovies' component={ListMovies} />
                {/* <Route exact path='/editperson' component={EditPerson} /> */}
                <Route exact path='/Scrape' component={Scrape} />
                <Route exact path='/createperson' component={ExtendedInfoAccordians} />
                <Route exact path='/moviewikilink' component={ImportMovies} />
                <Route exact path='/editpersondata' component={Editpersoncomponent} />
                <Route exact path='/content' component={Content} />
                <Route exact path='/ImportMovies' component={ImportMovies} />
                <Route exact path='/rankContent' component={RankContents} />
                <Route exact path='/unPublishedContents' component={UnPublishedContentsList} />
                <Route exact path='/publishedContents' component={PublishedContentsList} />
                <Route exact path='/listPushNotificationCounters' component={ListPNCounters} />
                <Route exact path='/listVideoPlayCounters' component={VideoPlayCounters} />
                <Route exact path='/creatorAnalytics' component={CreatorAnalytics} />
                <Route path='/preview/:data' exact component={Preview} />
                <Route path='/editPeople' component={CreatePeople} />
                <Route exact path='/createPeople' component={CreatePeople} />
                <Route exact path='/listPeople' component={ListPeople} />
                <Route exact path='/MovieList' component={MovieList} />
                <Route exact path='/listCompanies' component={ListCompanies} />
                <Route exact path='/listJobs' component={ListJobs} />
                <Route exact path='/listPages' component={ListPages} />
                <Route exact path='/editContent' component={EditContent} />
                <Route exact path='/duplicateContent' component={DuplicateContent} />
                <Route exact path='/createTemplate' component={CreateEditTemplate} />
                <Route exact path='/ImageTemplate' component={ImageTemplate} />
                <Route exact path='/listPages' component={ListPages} />
                <Route exact path='/listArticles' component={ListArticles} />
                <Route exact path='/listTeams' component={TeamsList} />
                <Route exact path='/featuredMatches' component={FeaturedMatches} />
                <Route exact path='/createTeam' component={CreateOrEditTeam} />
                <Route exact path='/userSignUps' component={UserSignUps} />
                <Route exact path='/referralUserSignups' component={ReferralUserSignups} />
                <Route exact path='/creatorsPointsReport' component={CreatorsPoints} />
                <Route exact path='/createCampaign' component={CreateCampaign} />
                <Route exact path='/jobs' component={Job} />
                <Route exact path='/draftJobs' component={DraftJobs} />
                <Route exact path='/activeJobs' component={ActiveJobs} />
                <Route exact path='/listCompany' component={ListCompany} />
                <Route exact path='/editJob' component={EditJob} />
                <Route exact path='/getmovieandpersonurls' component={MovieAndPersonURLs} />
                <Route exact path={'/pointsoverride'} component={SearchPointsOverRide} />
                <Route exact path={'/TfidbUserReport'} component={UserReportDashboard} />
                <Route exact path={'/editperson'} component={ExtendedInfoAccordians} />
                <Route exact path={'/TfidbPN'} component={SendPNManuallyInputForm} />
                <Route exact path={'/ImportPersonExtendedInfo'} component={ImportPersonExtendedInfo} />
                <Route component={NotFound} />
              </Switch>
            </div>
          </div>
          <Footer />
        </BrowserRouter>
      </ApolloProvider>
    </div>
  )
}

export default withAuthenticator(App, true)
